import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { setRecentUser } from "../lib/recent";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => { setRecentUser(r.data.id); setUser(r.data); }).catch(() => { setRecentUser(null); setUser(false); });
  }, []);

  useEffect(() => {
    if (!user) return;
    const ping = () => document.visibilityState === "visible" && api.get("/auth/me").catch(() => {});
    const t = setInterval(ping, 20000);
    window.addEventListener("focus", ping);
    return () => { clearInterval(t); window.removeEventListener("focus", ping); };
  }, [user]);

  const saveSession = useCallback((data) => {
    const { token, ...u } = data;
    localStorage.setItem("dss_token", token);
    setRecentUser(u.id);
    setUser(u);
    return u;
  }, []);

  const login = async (identifier, password, role) => saveSession((await api.post("/auth/login", { identifier, password, ...(role ? { role } : {}) })).data);
  const register = async (payload) => saveSession((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("dss_token");
    setRecentUser(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
